import React from 'react';
import { FiPlusCircle } from 'react-icons/fi';
import { notify } from '../../Shared/toast';
import ProductForm from './shared/ProductForm';

function AddNewProduct() {
  const [isLoading, setIsLoading] = React.useState(false);

  const categories = [
    'Grocery', 'Beverages', 'Dairy', 'Meat',
    'Vegetables', 'Fruits', 'Cleaning', 'Others',
  ];

  const units = ['Piece', 'Kg', 'Liter', 'Packet', 'Dozen', 'Box'];

  const initialValues = {
    productName: '',
    productNameBn: '',
    category: '',
    subCategory: '',
    barcode: '',
    purchasePrice: '',
    sellingPrice: '',
    quantity: '',
    unit: '',
    minStockLevel: '',
    description: '',
    image: null,
  };

  const handleSubmit = async (values, { resetForm }) => {
    setIsLoading(true);
    try {
      // Simulate API call
      await new Promise((resolve) => { setTimeout(resolve, 1500); });
      notify.success('Product added successfully!');
      resetForm();
    } catch (error) {
      notify.error('Failed to add product. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-4xl mx-auto bg-white rounded-lg shadow">
      <h1 className="text-2xl font-bold mb-6 text-gray-800">Add New Product</h1>
      <ProductForm
        initialValues={initialValues}
        onSubmit={handleSubmit}
        isLoading={isLoading}
        categories={categories}
        units={units}
        submitButtonText={(
          <>
            <FiPlusCircle className="mr-2" />
            Add Product
          </>
        )}
      />
    </div>
  );
}

export default AddNewProduct;
